<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-card v-if="visibleSensors.length > 0" outlined tile class="pt-3 pr-1 pl-1">
        <v-btn text @click="isConfitionView = !isConfitionView" color="primary">
            {{!isConfitionView ? "表示条件を表示する" : "表示条件を隠す"}}
        </v-btn>
        <!-- <v-divider v-if="!isConfitionView" class="mb-2" /> -->
        <v-expand-transition>
            <template v-if="isConfitionView">
                <v-toolbar flat v-if="!$vuetify.breakpoint.xs">
                    <v-select
                        v-model="measureChartCondition.range"
                        :items="measureChartRanges"
                        item-text="text"
                        item-value="value"
                        label="表示範囲"
                        hide-details
                        style="width:64px" />
                    <template v-if="measureChartCondition.range == 'month'">
                        <v-btn icon @click="onClickMeasureChartPreviusMonth" color="primary">
                            <v-icon>mdi-chevron-left-circle</v-icon>
                        </v-btn>
                        <v-select
                            v-model="measureChartCondition.year"
                            :items="years"
                            item-text="text"
                            item-value="value"
                            hide-details />
                        <v-select
                            v-model="measureChartCondition.month"
                            class="ml-2"
                            :items="months"
                            item-text="text"
                            item-value="value"
                            hide-details />
                        <v-btn icon @click="onClickMeasureChartNextMonth" color="primary">
                            <v-icon>mdi-chevron-right-circle</v-icon>
                        </v-btn>
                    </template>
                    <template v-else-if="measureChartCondition.range == 'day'">
                        <v-btn icon @click="onClickMeasureChartPreviusDay" color="primary">
                            <v-icon>mdi-chevron-left-circle</v-icon>
                        </v-btn>
                        <DatePicker 
                            label="表示日"
                            dense
                            :clearable="false"
                            v-model="measureChartCondition.date" />
                        <v-btn icon @click="onClickMeasureChartNextDay" color="primary">
                            <v-icon>mdi-chevron-right-circle</v-icon>
                        </v-btn>
                    </template>
                    <template v-else-if="measureChartCondition.range == 'day_range'">
                        <table>
                            <tr>
                                <td>
                                    <DatePicker 
                                        label="開始日"
                                        dense
                                        :clearable="false"
                                        v-model="measureChartCondition.dateFrom" />
                                </td>
                                <td>
                                    <DatePicker 
                                        label="終了日"
                                        dense
                                        :clearable="false"
                                        v-model="measureChartCondition.dateTo" />
                                </td>
                            </tr>
                        </table>
                    </template>
                </v-toolbar>
                <v-container v-else fluid class="pa-0">
                    <v-row>
                        <v-col cols="12" class="pb-0">
                            <v-select
                                v-model="measureChartCondition.range"
                                :items="measureChartRanges"
                                item-text="text"
                                item-value="value"
                                label="表示範囲"
                                hide-details
                                class="ml-2 mr-2" />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-toolbar flat>
                                <template v-if="measureChartCondition.range == 'month'">
                                    <v-btn icon @click="onClickMeasureChartPreviusMonth" color="primary">
                                        <v-icon>mdi-chevron-left-circle</v-icon>
                                    </v-btn>
                                    <v-select
                                        v-model="measureChartCondition.year"
                                        :items="years"
                                        item-text="text"
                                        item-value="value"
                                        hide-details />
                                    <v-select
                                        v-model="measureChartCondition.month"
                                        class="ml-2"
                                        :items="months"
                                        item-text="text"
                                        item-value="value"
                                        hide-details />
                                    <v-btn icon @click="onClickMeasureChartNextMonth" color="primary">
                                        <v-icon>mdi-chevron-right-circle</v-icon>
                                    </v-btn>
                                </template>
                                <template v-else-if="measureChartCondition.range == 'day'">
                                    <v-btn icon @click="onClickMeasureChartPreviusDay" color="primary">
                                        <v-icon>mdi-chevron-left-circle</v-icon>
                                    </v-btn>
                                    <DatePicker 
                                        label="表示日"
                                        dense
                                        :clearable="false"
                                        v-model="measureChartCondition.date" />
                                    <v-btn icon @click="onClickMeasureChartNextDay" color="primary">
                                        <v-icon>mdi-chevron-right-circle</v-icon>
                                    </v-btn>
                                </template>
                                <template v-else-if="measureChartCondition.range == 'day_range'">
                                    <table>
                                        <tr>
                                            <td>
                                                <DatePicker 
                                                    label="開始日"
                                                    dense
                                                    :clearable="false"
                                                    v-model="measureChartCondition.dateFrom" />
                                            </td>
                                            <td>
                                                <DatePicker 
                                                    label="終了日"
                                                    dense
                                                    :clearable="false"
                                                    v-model="measureChartCondition.dateTo" />
                                            </td>
                                        </tr>
                                    </table>
                                </template>
                            </v-toolbar>
                        </v-col>
                    </v-row>
                </v-container>
            </template>
        </v-expand-transition>
        <v-container fluid class="pa-0">
            <v-row dense>
                <v-col class="pa-0">
                        <v-checkbox
                            v-model="isMixChart"
                            class="ml-2 mt-0 pa-0"
                            label="全てのセンサーを重ねる"
                            hide-details />
                    <!-- <v-toolbar dense flat>
                        <v-checkbox
                            v-model="isMixChart"
                            class="ml-2 mt-0 pa-0"
                            label="全てのセンサーを重ねる"
                            hide-details />
                    </v-toolbar> -->
                </v-col>
            </v-row>
            <template v-if="isMixChart || visibleSensors.length == 1">
                <v-row>
                    <v-col cols="12">
                        <Sensor :sensors="visibleSensors" :condition="measureChartCondition" />
                    </v-col>
                </v-row>
            </template>
            <template v-else-if="visibleSensors.length > 0">
                <v-row>
                    <template v-for="sensor in visibleSensors">
                        <v-col v-if="sensor.body.enabled" :key="sensor.body.sensorKey" cols="12" xs="12" sm="12" md="12" lg="6" xl="4">
                            <Sensor :sensors="[sensor]" :condition="measureChartCondition" />
                        </v-col>
                    </template>
                </v-row>
            </template>
        </v-container>
    </v-card>
</template>

<script>
    Date.prototype.toFormatString = function (format) {
        const year = this.getFullYear()
        const month = this.getMonth() + 1
        const month2 = ("0" + month).slice(-2)
        const day2 = ("0" + this.getDate()).slice(-2)
        const hour2 = ("0" + this.getHours()).slice(-2)
        const minute2 = ("0" + this.getMinutes()).slice(-2)
        const second2 = ("0" + this.getSeconds()).slice(-2)

        const formattedValue = format.replace("yyyy", year).replace("MM", month2).replace("dd", day2).replace("HH", hour2).replace("mm", minute2).replace("ss", second2)

        return formattedValue
    }

    import db from '@/firebase/firestore.js'
    import DatePicker from '@/components/tools/DatePicker';
    import Sensor from '@/components/box/Sensor';

    export default {
        props: {
            box: null,
            sensors: null,
        },
        components: {
            DatePicker,
            Sensor
        },
        data: function () {
            return {
                /** チャートの表示月選択用の年と月 */
                years: [],
                months: [],                
                /** 測定チャートの表示範囲 */
                measureChartRanges: [
                    {value:"month", text:"月"},
                    {value:"day", text:"日"},
                    {value:"day_range", text:"日範囲"},
                ],
                /** 測定チャートの表示条件を表示するか否か */
                isConfitionView: false,
                /** 測定チャートの表示条件 */
                measureChartCondition: {
                    range: "month",
                    year: 2020,
                    month: 8,
                    date: "",
                    dateFrom: "",
                    dateTo: "",
                    viewRange: function () {

                        const dayToMSec = 1000 * 60 * 60 * 24
                        const viewRange = {
                            from: null,
                            to: null,
                            fromTime: null,
                            toTime: null,
                            fromText: null,
                            toText: null
                        }
                        switch (this.range) {
                            case "month":
                                viewRange.from = new Date(this.year, this.month - 1, 1, 0, 0, 0) 
                                viewRange.to = new Date(this.year, this.month, 1, 0, 0, 0)
                                break;
                            case "day":
                                viewRange.from = new Date(this.date.replace(/-/g, "/") + " 00:00:00")
                                viewRange.to = new Date(viewRange.from.getTime() + dayToMSec)
                                break;
                            case "day_range":
                                viewRange.from = new Date(this.dateFrom.replace(/-/g,"/") + " 00:00:00")
                                viewRange.to = new Date((new Date(this.dateTo.replace(/-/g,"/") + " 00:00:00")).getTime() + dayToMSec)
                                break;
                        }
                        viewRange.fromTime = viewRange.from.getTime()
                        viewRange.fromText = viewRange.from.toFormatString("yyyy-MM-dd")
                        viewRange.toTime = viewRange.to.getTime()
                        viewRange.toText = viewRange.to.toFormatString("yyyy-MM-dd")
                        
                        // console.log("measureChartConfition", "viewRange", viewRange, this.date, this.year, this.month)

                        // console.log("ViewRange", viewRange)
                        return viewRange
                    }
                },
                /** 複数のセンサーのチャートを重ねて表示するか否か */
                isMixChart: true,
                /** 対象となる全ボックス */
                targetBoxes: [],
                /** 警報監視を解放するメソッドが格納された配列 */
                todayAlarmWatcherReleasers: [],
                /** 警報通知を解放するメソッドが格納された配列 */
                todayNotificationWatcherReleasers: []
            }
        },
        watch: {
            measureChartCondition: {
                handler: function (value, old) {
                    // console.log("SensorList", "watch", "condition", "changed", value, this.sensors)                    
                    if (value == null) return
                    this.onChangedCondition()
                },
                deep: true
            }
        },
        computed: {
            /**
             * ユーザーUID(グループユーザーの圃場参照時は、そのユーザーのUID)
             */
            userUID: function () {
                return this.$store.getters["userUID"]
            },
            /** 共有モード */
            shareMode: function () {
                return this.$store.getters["shareMode"]
            },
            /** 共有モードの全種類 */
            shareModeTypes: function () {
                return this.$store.getters["shareModeTypes"]
            },
            /** グループユーザーの圃場管理を参照中は True */
            isShareMode: function () {
                if (this.shareMode == this.shareModeTypes.groupUserWork) {
                    return true
                }
                return false
            },
            /** 表示対象のセンサーが格納された配列 */
            visibleSensors: function () {
                return this.sensors.filter((v)=>v.body.enabled && v.isVisible)
            },            
        },
        mounted: async function () {
            const self = this
            const d = new Date()
            /**
             * 年月のコンボボックス初期化
             */
            for (var year=d.getFullYear() ; year>=2020; year--) {
                this.years.push(
                    {value: year, text: year+"年"}
                )
            }
            for (var month = 1; month<=12; month++) {
                this.months.push(
                    {value: month, text: month+"月"}
                )
            }

            /**
             * チャートの表示対象年月の初期設定(当月)
             */
            this.measureChartCondition.range = "day"
            this.measureChartCondition.year = d.getFullYear()
            this.measureChartCondition.month = d.getMonth() + 1            
            this.measureChartCondition.date = d.toFormatString("yyyy-MM-dd")
            this.measureChartCondition.dateFrom = d.toFormatString("yyyy-MM-dd")
            this.measureChartCondition.dateTo = d.toFormatString("yyyy-MM-dd")

            /**
             * 対象となる全ボックスを収集
             */
            this.targetBoxes = []

            for (var sensor of this.sensors) {
                var targetBox = this.targetBoxes.find((v)=>v.boxMaster.boxIdentificationCode == sensor.boxMaster.boxIdentificationCode)
                if (targetBox == null) {
                    targetBox = {
                        boxMaster: sensor.boxMaster,
                        sensors: [],
                        cacheDailyAlarm: {},
                        cacheDailyNotifications: {}
                    }
                    targetBox.sensors.push(sensor)
                    this.targetBoxes.push(targetBox)
                } else {
                    targetBox.sensors.push(sensor)
                }
            }

            console.log(this.targetBoxes)

            /**
             * 当日の警報を監視
             */
            const currentDate = (new Date()).toFormatString("yyyy-MM-dd")

            this.targetBoxes.forEach(function(box){
                const releaser = db.collection("environments").doc(box.boxMaster.boxIdentificationCode)
                .collection("alarm_histories").doc(currentDate)
                .onSnapshot(function(doc){
                    if (box.cacheDailyAlarm[currentDate] != null) {
                        const viewRange = self.measureChartCondition.viewRange()
                        if (viewRange.fromText <= currentDate && viewRange.toText > currentDate) {
                            // 当日が表示条件内であれば処理
                            // 更新された異常履歴を取得
                            const alarm = doc.data()
                            // キャッシュを更新
                            box.cacheDailyAlarm[currentDate] = alarm
                            // 警報が発生した対象のボックスに対して、警報を追加
                            box.sensors.forEach(function(sensor){
                                const sensorLastAlarm = sensor.alarmHistories.length == 0 ? null : sensor.alarmHistories[sensor.alarmHistories.length - 1]
                                var targetHistories = null
                                if (sensorLastAlarm == null) {
                                    targetHistories = alarm.histories.filter((v)=>v.sensorKey == sensor.body.sensorKey)
                                } else {
                                    targetHistories = alarm.histories.filter((v)=>v.time > sensorLastAlarm.time && v.sensorKey == sensor.body.sensorKey)
                                }
                                for (var history of targetHistories) {
                                    self.setAlarmHistoriesToSensor(box, sensor, alarm)
                                }
                            })
                        }
                    }
                })
                self.todayAlarmWatcherReleasers.push(releaser)
            })

            /**
             * 警報通知を監視
             */
            this.targetBoxes.forEach(function(box){
                db.collection("environments").doc(box.boxMaster.boxIdentificationCode)
                .collection("notification_histories").orderBy("seqNo", "desc").limit(1).get().then(function(snapShot){
                    var currentMaxSeqNo = 0
                    if (snapShot.size > 0) {
                        currentMaxSeqNo = snapShot.docs[snapShot.size-1].data().seqNo
                    }
                    const releaser = db.collection("environments").doc(box.boxMaster.boxIdentificationCode)
                    .collection("notification_histories")
                    .where("seqNo", ">", currentMaxSeqNo)
                    .onSnapshot(function(docs) {
                        docs.docChanges().forEach(function(change){
                            const notification = change.doc.data()
                            const cache = box.cacheDailyNotifications[notification.alarm.alarmDate]
                            if (cache == null) {
                                box.cacheDailyNotifications[notification.alarm.alarmDate] = {
                                    notifications: [notification]
                                }
                            } else {
                                cache.notifications.push(notification)
                            }
                            const targetSensor = box.sensors.find((v)=>v.body.sensorKey == notification.alarm.sensorKey)
                            if (targetSensor != null) {
                                const targetAlarm = targetSensor.alarmHistories.find((v)=>v.time == notification.alarm.time)
                                if (targetAlarm != null) {
                                    targetAlarm.notifications.push(notification)
                                } else {
                                    console.log("SensorList", "mounted", "unknown alarm notification", targetSensor, notification)
                                }
                            } else {
                                console.log("SensorList", "mounted", "unknown sensor notification", notification)
                            }                            
                        })
                    })
                    self.todayNotificationWatcherReleasers.push(releaser)
                })
            })

            // watchingBoxes.forEach(function(boxIdentificationCode){

            //     db.collection("environments").doc(boxIdentificationCode)
            //     .collection("notification_histories").orderBy("seqNo", "desc").limit(1).get().then(function(snapShot){
            //         var currentMaxSeqNo = 0
            //         if (snapShot.size > 0) {
            //             currentMaxSeqNo = snapShot.docs[snapShot.size-1].data().seqNo
            //         }
            //         // console.log("SensorList", "mounted", "box notification current seqNo", boxIdentificationCode, currentMaxSeqNo)
            //         const releaser = db.collection("environments").doc(boxIdentificationCode)
            //         .collection("notification_histories")
            //         .where("seqNo", ">", currentMaxSeqNo)
            //         .onSnapshot(function(docs) {
            //             docs.docChanges().forEach(function(change){
            //                 const notification = change.doc.data()
            //                 // console.log("SensorList", "mounted", "new notification", boxIdentificationCode, notification.seqNo)
            //                 self.setNotification(boxIdentificationCode, notification)
            //             })
            //         })
            //         self.todayNotificationWatcherReleasers.push(releaser)
            //     })
            //     // console.log("SensorList", "mounted", "box notification watch start", boxIdentificationCode)
            // })
        },
        beforeDestroy: function () {
            this.todayAlarmWatcherReleasers.forEach(function(releaser){
                releaser()
                // console.log("SensorList","beforeDestroy","alarm listener released")
            })
            this.todayNotificationWatcherReleasers.forEach(function(releaser){
                releaser()
                // console.log("SensorList","beforeDestroy","alarm notification listener released")
            })
        },
        methods: {
            /**
             * 測定チャートの前月ボタン押下時
             */
            onClickMeasureChartPreviusMonth: function () {
                if (this.measureChartCondition.month == 1) {
                    this.measureChartCondition.year--
                    this.measureChartCondition.month = 12
                } else {
                    this.measureChartCondition.month--
                }
            },
            /**
             * 測定チャートの翌月ボタン押下時
             */
            onClickMeasureChartNextMonth: function () {
                if (this.measureChartCondition.month == 12) {
                    this.measureChartCondition.year++
                    this.measureChartCondition.month = 1
                } else {
                    this.measureChartCondition.month++
                }
            },
            /**
             * 測定チャートの前日ボタン押下時
             */
            onClickMeasureChartPreviusDay: function () {
                this.measureChartCondition.date = (new Date(this.measureChartCondition.date)).addDay(-1).toFormatString("yyyy-MM-dd")
            },
            /**
             * 測定チャートの翌日ボタン押下時
             */
            onClickMeasureChartNextDay: function () {
                this.measureChartCondition.date = (new Date(this.measureChartCondition.date)).addDay(1).toFormatString("yyyy-MM-dd")
            },
            /**
             * 指定されたボックスの指定されたセンサーに、指定された警報データの中の履歴データをセットする
             */
            setAlarmHistoriesToSensor: function (box, sensor, alarm) {
                const histories = alarm.histories.filter((v)=>v.alarmType >= 1 && v.alarmType <= 3 && v.sensorKey == sensor.body.sensorKey)
                const self = this
                histories.forEach(function(history, index){
                    const item = {
                        date: alarm.date,
                        alarmData: history.alarmData,
                        alarmType: history.alarmType,
                        sensorKey: history.sensorKey,
                        time: history.time,
                        notifications: []
                    }
                    if (sensor.alarmHistories.findIndex((v)=>v.time == item.time) < 0) {
                        sensor.alarmHistories.push(item)
                        // console.log("sensorList", "setAlarmHistoriesToSensor", "alarm history added", item.sensorKey, (new Date(item.time)).toFormatString("yyyy-MM-dd HH:mm"), sensor.alarmHistories.length)
                    } else {
                        // console.log("same alarm history setted", item.sensorKey, (new Date(item.time)).toFormatString("yyyy-MM-dd HH:mm"))
                    }
                    
                    // self.setNotificationHistoriesToAlarmHistory(box, item)
                    if (index == histories.length - 1) {
                        sensor.alarmHistories.sort(function(x, y) {
                            if (x.time > y.time) return 1
                            if (x.time < y.time) return -1
                            return 0
                        })
                    }

                    // キャッシュされている警報通知と紐つける
                    const notificationCache = box.cacheDailyNotifications[alarm.date]

                    if (notificationCache != null) {
                        const targetNotifications = notificationCache.notifications.filter((v)=>v.alarm.sensorKey == item.sensorKey && v.alarm.time == item.time)
                        targetNotifications.forEach(function(notification){
                            item.notifications.push(notification)
                            console.log("SensorList", "setAlarmHistoriesToSensor", "alarm notification added", item.sensorKey, (new Date(item.time).toFormatString("yyyy-MM-dd HH:mm:ss")), (new Date(notification.alarm.time).toFormatString("yyyy-MM-dd HH:mm:ss")), )
                        })
                    } else {
                        console.log("SensorList", "setAlarmHistoriesToSensor", "alarm notification cache none", alarm.date)
                    }
                })
            },
            /**
             * 警報履歴のキャッシュを更新
             * callback は、処理終了後に実行するコールバック先を指定
             */
            refreshAlarmNotificationHistoriesCache: function (box, targetDate, callback) {
                const cache = box.cacheDailyNotifications[targetDate]
                if (cache == null) {
                    box.cacheDailyNotifications[targetDate] = {notifications:[]}
                    db.collection("environments").doc(box.boxMaster.boxIdentificationCode)
                    .collection("notification_histories")
                    .where("alarm.alarmDate", "==", targetDate)
                    .get().then(function(snapShot) {
                        if (snapShot.size > 0) {
                            snapShot.forEach(function(doc){
                                const notification = doc.data()
                                box.cacheDailyNotifications[targetDate].notifications.push(notification)
                                console.log("alarm notification cached", snapShot.size, box.cacheDailyNotifications[targetDate].notifications.length)
                                if (box.cacheDailyNotifications[targetDate].notifications.length == snapShot.size) {
                                    // console.log("notification_histories get complete", targetDate)
                                    callback()
                                }
                            })
                        } else {
                            // console.log("alarm notification none", targetDate)
                            callback()
                        }
                    })
                } else {
                    // console.log("notification_histories cached", targetDate)
                    callback()
                }
            },
            /**
             * 表示条件変更時
             */
            onChangedCondition: async function () {

                console.log("SensorList", "onChangedCondition")

                const self = this
                
                // ボックス毎に条件に該当する全警報履歴を日毎に検索
                const viewRange = this.measureChartCondition.viewRange()
                const dayToMSec = 1000 * 60 * 60 * 24

                this.targetBoxes.forEach(function(box){

                    box.sensors.forEach(function(sensor){
                        sensor.alarmHistories = []
                    })

                    for (var currentTime = viewRange.fromTime; currentTime < viewRange.toTime; currentTime += dayToMSec) {
    
                        // 対象日付
                        const targetDate = (new Date(currentTime)).toFormatString("yyyy-MM-dd")

                        // まずは、警報通知のキャッシュを更新
                        self.refreshAlarmNotificationHistoriesCache(
                            box, 
                            targetDate, 
                            function () {

                                // 警報通知のキャッシュ更新終了で、警報の検索
                                // console.log("alarm notification refreshed", targetDate)

                                // 該当する日のキャッシュが存在すれば、それを使用する
                                // 存在しなければ、データベースから取得
                                const cache = box.cacheDailyAlarm[targetDate]

                                if (cache == null) {
                                    // console.log("alarm history no cache", targetDate)

                                    db.collection("environments").doc(box.boxMaster.boxIdentificationCode)
                                    .collection("alarm_histories")
                                    .where("date", "==", targetDate)
                                    .get().then(function(snapShot) {
                                        if (snapShot.size > 0) {
                                            const doc = snapShot.docs[0]
                                            const alarm = doc.data()
                                            box.cacheDailyAlarm[targetDate] = {alarm: alarm}
                                            box.sensors.forEach(function(sensor){
                                                // console.log("condition", box, sensor, alarm)
                                                self.setAlarmHistoriesToSensor(box, sensor, alarm)
                                                // console.log("alarm history data set", box, sensor, alarm)
                                            })
                                        } else {
                                            box.cacheDailyAlarm[targetDate] = {alarm: null}
                                        }
                                    })
                                } else {
                                    console.log("alarm history cached", targetDate)
                                    if (cache.alarm != null) {
                                        box.sensors.forEach(function(sensor){
                                            // console.log("condition", box, sensor, alarm)
                                            self.setAlarmHistoriesToSensor(box, sensor, cache.alarm)
                                        })
                                    }
                                }
                            }
                        )
                    }
                })

                // for (var box of this.targetBoxes) {

                //     for (var sensor of box.sensors) {
                //         sensor.alarmHistories = []
                //     }

                //     for (var currentTime = viewRange.fromTime; currentTime < viewRange.toTime; currentTime += dayToMSec) {
    
                //         // 対象日付
                //         const targetDate = (new Date(currentTime)).toFormatString("yyyy-MM-dd")

                //         // 該当する日のキャッシュが存在すれば、それを使用する
                //         // 存在しなければ、データベースから取得
                //         const cache = box.cacheDailyAlarm[targetDate]

                //         if (cache == null) {
                //             await db.collection("environments").doc(box.boxMaster.boxIdentificationCode)
                //             .collection("alarm_histories")
                //             .where("date", "==", targetDate)
                //             .get().then(function(snapShot) {
                //                 if (snapShot.size > 0) {
                //                     const doc = snapShot.docs[0]
                //                     const alarm = doc.data()
                //                     box.cacheDailyAlarm[targetDate] = {alarm: alarm}
                //                     for (var sensor of box.sensors){
                //                         self.setAlarmHistoriesToSensor(sensor, alarm)
                //                     }
                //                 } else {
                //                     box.cacheDailyAlarm[targetDate] = {alarm: null}
                //                 }
                //             })
                //         } else {
                //             if (cache.alarm != null) {
                //                 for (var sensor of box.sensors){
                //                     self.setAlarmHistoriesToSensor(sensor, cache.alarm)
                //                 }
                //             }
                //         }
                //     }
                // }
            },
            // setHistories: function (sensor, dailyHistory) {
            //     const histories = dailyHistory.histories.filter((v)=>v.alarmType >= 1 && v.alarmType <= 3 && v.sensorKey == sensor.body.sensorKey)                    
            //     for (var history of histories) {
            //         const item = {
            //             date: dailyHistory.date,
            //             alarmData: history.alarmData,
            //             alarmType: history.alarmType,
            //             sensorKey: history.sensorKey,
            //             time: history.time,
            //             notifications: []
            //         }
            //         sensor.alarmHistories.push(item)
            //     }
            // },
            // setNotification: function (boxIdentificationCode, notification) {
            //     const sensor = this.sensors.find((v)=>v.boxMaster.boxIdentificationCode == boxIdentificationCode && v.body.sensorKey == notification.alarm.sensorKey)
            //     if (sensor != null) {
            //         const history = sensor.alarmHistories.find((v)=>v.time == notification.alarm.time && v.alarmType == notification.alarm.alarmType)
            //         if (history != null) {
            //             history.notifications.push(notification)
            //             // console.log("sensorList", "setNotification", "alarm notification added", sensor, history, notification)
            //         } else {
            //             // console.log("sensorList", "setNotification", "unknown alarm notification", notification)
            //         }
            //     } else {
            //         // console.log("sensorList", "setNotification", "unknown sensor notification", notification)
            //     }
            // }
        }
    }
</script>
